import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { SolutionBreakdown } from '../components/SolutionBreakdown';
import { Testimonials } from '../components/Testimonials';
import { PricingCTA } from '../components/PricingCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <article className="w-full min-h-screen bg-white" data-id="element-306">
      <Hero data-id="element-307" />
      <PainSection data-id="element-308" />
      <SolutionBreakdown data-id="element-309" />
      <Testimonials data-id="element-310" />
      <PricingCTA data-id="element-311" />
      <FAQ data-id="element-312" />
      <Footer data-id="element-313" />
    </article>;
}